<template>
  <div>
    <input
      :id="'checkbox' + id"
      class="checkbox"
      type="checkbox"
      :value="modelValue"
      @input="onInput"
      :checked="modelValue"
    >
    <label :for="'checkbox' + id" class="checkbox__label">
      <slot />
    </label>
  </div>
</template>

<script setup>
const $emit = defineEmits()
const props = defineProps({
  id: [Number, String],
  modelValue: Boolean
})

const onInput = (event) => {
  $emit('update:modelValue', event.target.checked);
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: none;
  opacity: 0;

  &__label {
    position: relative;
    color: $white;
    font-size: 16px;
  }
}

.checkbox + .checkbox__label::before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 50%;
  background-color: #FEBD5B;
  margin-right: 10px;
}

.checkbox + .checkbox__label::after {
  content: '';
  position: absolute;
  top: 7px;
  left: 5px;
  display: inline-block;
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: $white;
  opacity: 0;
  transition: 0.1s;
}

.checkbox:checked + .checkbox__label::after {
  opacity: 1;
}

.checkbox + .checkbox__label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  user-select: none;
}

@media (max-width: 1000px) {
  .checkbox__label {
    font-size: 18px;
  }
}
</style>